import { createUseStyles, Styles } from '@pff-consumer/tweed-ui/web-styles'
import { SubscriptionPlans } from '@pff-consumer/schema'
import type { SubscriptionPlanType } from '@pff-consumer/schema'

interface SubscriptionStyles {
  subscriptionButton: Styles
  subscriptionInfoIcon: Styles
  subscriptionLabel: Styles
  header: Styles
  subHeader: Styles
  text: Styles
  textContainer: Styles
  messagesContainer: Styles
  icon: Styles
  subscriptionPlanContainer: Styles
  annualPlanTile: Styles
  monthlyPlanTile: Styles
  loginLink: Styles
}

export const useStyles = createUseStyles<SubscriptionStyles, SubscriptionPlanType>((theme) => {
  return {
    subscriptionButton: {
      border: ` ${theme.calcUnit(1)} solid ${theme.colors.inverseBackgroundColor}`,
      cursor: 'pointer',
      borderRadius: theme.calcUnit(theme.borderRadius.roundedDefault),
      backgroundColor: theme.colors.backgroundColor,
      color: theme.colors.textColor,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      maxWidth: theme.calcUnit(410),
      boxShadow: '0px 0px 8px 0px #00000029',
    },
    subscriptionInfoIcon: {
      padding: '18px 8px 18px 12px',
    },
    subscriptionLabel: {
      fontWeight: '500',
      fontSize: theme.calcUnit(16),
      lineHeight: theme.calcUnit(20),
      fontFamily: 'Roboto, sans-serif',
      padding: '16px 0',
    },
    header: {
      fontFamily: 'Roboto',
      fontWeight: '700',
      fontStyle: 'normal',
      fontSize: theme.calcUnit(20),
      lineHeight: theme.calcUnit(20),
      marginTop: theme.calcUnit(theme.spacing.s2),
      paddingBottom: theme.calcUnit(theme.spacing.s3),
      borderBottom: `${theme.calcUnit(1)} solid ${theme.colors.textFieldBorderColor}`,
    },
    subHeader: {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontSize: theme.calcUnit(12),
      marginTop: theme.calcUnit(theme.spacing.s2),
      paddingBottom: theme.calcUnit(theme.spacing.s1),
    },
    textContainer: {
      lineHeight: theme.calcUnit(20),
      marginBottom: theme.calcUnit(theme.spacing.s2),
    },
    messagesContainer: {
      marginBottom: theme.calcUnit(theme.spacing.s4),
    },
    text: {
      fontSize: theme.calcUnit(14),
      fontFamily: 'Roboto',
      paddingLeft: theme.calcUnit(theme.spacing.s2),
    },
    icon: {
      display: 'inline',
    },
    subscriptionPlanContainer: {
      display: 'flex',
      flexDirection: 'column',
      // Ux asked to keep this one commented
      // We will need this when we decide to go with 2col for plan selection on desktop
      // ...theme.breakpoint.up('lg', {
      //   flexDirection: 'row',
      //   justifyContent: 'space-between',
      //   alignItems: 'flex-end',
      //   gap: theme.calcUnit(8),
      // }),
    },
    annualPlanTile: (plan) => {
      const isAnnualPlanSelected = plan === SubscriptionPlans.PREMIUM_ANNUAL
      return {
        marginTop: theme.calcUnit(theme.spacing.s4),
        color: isAnnualPlanSelected ? theme.colors.webInverseTextColor : theme.colors.webLinkText,
        textAlign: 'left',
        backgroundColor: isAnnualPlanSelected ? '#0A1B33' : theme.colors.backgroundColor,
        border: isAnnualPlanSelected ? '2px solid' : '1px solid',
        borderColor: isAnnualPlanSelected ? '#3388FF' : theme.colors.webLogoBorder,
        borderRadius: theme.calcUnit(theme.borderRadius.roundedMd),
        cursor: 'pointer',
      }
    },
    monthlyPlanTile: (plan) => {
      const isMonthlyPlanSelected =
        plan === SubscriptionPlans.PREMIUM_MONTHLY_SEASON ||
        plan === SubscriptionPlans.PREMIUM_MONTHLY_SEASON_PASS ||
        plan === SubscriptionPlans.PREMIUM_MONTHLY_2024_DRAFT_EARLY ||
        plan === SubscriptionPlans.PREMIUM_MONTHLY_2024_DRAFT_PEAK
      return {
        marginTop: theme.calcUnit(theme.spacing.s4),
        color: isMonthlyPlanSelected ? theme.colors.webInverseTextColor : theme.colors.webLinkText,
        textAlign: 'left',
        backgroundColor: isMonthlyPlanSelected ? '#0A1B33' : theme.colors.backgroundColor,
        border: isMonthlyPlanSelected ? '2px solid' : '1px solid',
        borderColor: isMonthlyPlanSelected ? '#3388FF' : theme.colors.webLogoBorder,
        borderRadius: theme.calcUnit(theme.borderRadius.roundedMd),
        cursor: 'pointer',
      }
    },
    loginLink: {
      fontFamily: 'Roboto, sans-serif',
      fontWeight: '500',
      fontStyle: 'Medium',
      fontSize: theme.calcUnit(16),
      lineHeight: theme.calcUnit(18),
      color: '#3388FF',
      textAlign: 'center',
      marginTop: theme.calcUnit(28),
      marginBottom: theme.calcUnit(theme.spacing.s5),
    },
  }
})
